import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,282 C1489.35529,282 1920,712.757647 1920,1242 C1920,1319.13882 1911.07765,1395.14824 1893.45882,1467.88235 L1882.95529,1511.02588 L1322.76706,1511.02588 C1295.66118,1585.90588 1242.91765,1651.86353 1167.24706,1692.07059 C1119.36,1717.25647 1065.6,1730.69647 1011.61412,1730.69647 C888.169412,1730.69647 775.567059,1663.04471 717.854118,1554.05647 C711.981176,1542.87529 705.995294,1528.30588 700.009412,1511.02588 L37.0447059,1511.02588 L26.5411765,1467.88235 C8.92235294,1395.14824 0,1319.13882 0,1242 C0,712.757647 430.644706,282 960,282 Z M1128.16941,1511.02588 C1175.83059,1461.67059 1189.38353,1385.88706 1155.50118,1321.96235 C1113.26118,1242.45176 751.736471,908.371765 751.736471,908.371765 C751.736471,908.371765 825.374118,1395.14824 867.501176,1474.65882 C874.842353,1488.55059 884.442353,1500.18353 894.72,1511.02588 L893.816471,1511.02588 C895.849412,1513.17176 898.334118,1514.64 900.367059,1516.56 C904.997647,1520.96471 909.741176,1525.03059 914.710588,1528.75765 C918.437647,1531.58118 922.390588,1534.06588 926.230588,1536.43765 C931.425882,1539.6 936.621176,1542.53647 942.155294,1545.24706 C946.447059,1547.16706 950.738824,1548.97412 955.256471,1550.66824 C960.677647,1552.58824 966.211765,1554.39529 971.971765,1555.75059 C976.715294,1556.99294 981.458824,1558.00941 986.202353,1558.8 C991.962353,1559.70353 997.609412,1560.26824 1003.36941,1560.49412 C1006.19294,1560.60706 1008.90353,1561.28471 1011.61412,1561.28471 C1013.53412,1561.28471 1015.45412,1560.60706 1017.37412,1560.60706 C1025.61882,1560.38118 1033.75059,1559.25176 1041.88235,1557.67059 C1045.60941,1556.88 1049.44941,1556.54118 1053.17647,1555.52471 C1064.92235,1552.36235 1076.44235,1548.29647 1087.51059,1542.31059 L1087.84941,1542.31059 L1087.84941,1542.19765 C1103.54824,1533.95294 1116.53647,1522.99765 1128.16941,1511.02588 Z M1489.69412,885.218824 L1602.40941,772.503529 L1482.69176,652.672941 L1369.86353,765.388235 L1489.69412,885.218824 Z M875.294118,630.762353 L1044.70588,630.762353 L1044.70588,471.289412 L875.294118,471.289412 L875.294118,630.762353 Z M430.305882,885.218824 L550.136471,765.388235 L437.421176,652.672941 L317.590588,772.503529 L430.305882,885.218824 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDashboardSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconDashboardSolid, _Component);

  var _super = _createSuper(IconDashboardSolid);

  function IconDashboardSolid() {
    _classCallCheck(this, IconDashboardSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconDashboardSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDashboard",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconDashboardSolid.displayName = "IconDashboardSolid";
  return IconDashboardSolid;
}(Component);

IconDashboardSolid.glyphName = 'dashboard';
IconDashboardSolid.variant = 'Solid';
IconDashboardSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDashboardSolid;
export { IconDashboardSolid };